import { ChangeDetectionStrategy, Component, computed, HostListener, inject, input, Injector, output } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { ZagButton } from '../button/button';
import { ZagIcon } from '../icon/icon';
import { TooltipDirective } from '../tooltip/tooltip.directive';
import type { BulkEditSection } from './bulk-edit-section.types';

@Component({
  selector: 'zag-selection-summary-panel',
  templateUrl: './selection-summary-panel.component.html',
  styleUrl: './selection-summary-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, ZagButton, ZagIcon, TooltipDirective],
})
export class SelectionSummaryPanelComponent {
  readonly sections = input.required<BulkEditSection[]>();
  readonly selectedCount = input.required<number>();
  readonly totalCount = input.required<number>();
  readonly allMatchingActive = input(false);

  readonly actionSelected = output<BulkEditSection>();
  readonly selectAllMatching = output<boolean>();
  readonly leaveSelection = output<void>();

  private readonly injector = inject(Injector);
  private readonly dialog = inject(Dialog);

  @HostListener('document:keydown.escape')
  protected onEscape(): void {
    if (this.dialog.openDialogs.length === 0) {
      this.leaveSelection.emit();
    }
  }

  readonly visibleSections = computed(() =>
    [...this.sections()]
      .filter(
        section =>
          (!section.visibilityCheck || section.visibilityCheck(this.injector)) && (!section.editCheck || section.editCheck(this.injector))
      )
      .sort((left, right) => left.priority - right.priority)
  );

  protected toggleAllMatching(): void {
    this.selectAllMatching.emit(!this.allMatchingActive());
  }
}
